module.exports = __webpack_public_path__ + "img/chrome-w.c9a0bd47.svg";